<template>
  <div class="root wrap1">
    <h1 class="common-title">{{ $t('payroll_management_1') }}</h1>
    <div class="wrap-content" v-load="loading">
      <!-- 薪资结构 -->
      <h2 style="font-size: 14px; margin: 0 0 12px 0">{{ $t('items.title1') }}</h2>
      <div class="cards">
        <el-card shadow="hover" @click.native="$router.push('/payroll/items/fixed')">
          <div class="card-meta">
            <div class="card-meta-icon">
              <img class="icon" src="~@/assets/img/salary_project_1.png" />
            </div>
            <div class="card-meta-detail">
              <div class="card-meta-title">
                <!-- 固定薪资项 -->
                <div class="card-title">{{ $t('meta.title.fixed') }}</div>
              </div>
              <div class="card-meta-desc">
                <p class="card-desc">{{ $t('desc1') }}</p>
              </div>
            </div>
          </div>
        </el-card>
        <el-card shadow="hover" @click.native="$router.push('/payroll/items/unfixed')">
          <div class="card-meta">
            <div class="card-meta-icon">
              <img class="icon" src="~@/assets/img/salary_project_2.png" />
            </div>
            <div class="card-meta-detail">
              <div class="card-meta-title">
                <!-- 非固定薪资项 -->
                <div class="card-title">{{ $t('meta.title.unfixed') }}</div>
              </div>
              <div class="card-meta-desc">
                <p class="card-desc">{{ $t('desc1') }}</p>
              </div>
            </div>
          </div>
        </el-card>
        <el-card shadow="hover" @click.native="$router.push('/payroll/items/import')">
          <div class="card-meta">
            <div class="card-meta-icon">
              <img class="icon" src="~@/assets/img/salary_project_3.png" />
            </div>
            <div class="card-meta-detail">
              <div class="card-meta-title">
                <!-- 导入项 -->
                <div class="card-title">{{ $t('meta.title.import') }}</div>
              </div>
              <div class="card-meta-desc">
                <p class="card-desc">{{ $t('desc2') }}</p>
              </div>
            </div>
          </div>
        </el-card>
      </div>
      <!-- 其它薪资项规则 -->
      <h2 style="font-size: 14px; margin: 16px 0 12px 0">{{ $t('items.title2') }}</h2>
      <el-card shadow="hover" style="width: 320px">
        <div class="card-meta" @click="$router.push('/payroll/items/other')">
          <div class="card-meta-icon">
            <img class="icon" src="~@/assets/img/salary_project_4.png" />
          </div>
          <div class="card-meta-detail">
            <div class="card-meta-title">
              <!-- 全勤奖 -->
              <div class="card-title">{{ $t('card.tit') }}</div>
              <el-tooltip class="item" effect="dark" :content="$t('payroll_management_6')" placement="top">
                <img class="doubt" src="~@/assets/img/icon_doubt.png" />
              </el-tooltip>
              <div class="switch">
                <el-popover
                  :disabled="!$p('menu.payroll.management.edit')"
                  trigger="click"
                  placement="top"
                  width="240"
                  v-model="switchVisible"
                >
                  <p class="el-icon-warning status-tip">
                    {{ switchValue ? $t('payroll_managemen_23') : $t('payroll_management_52') }}
                  </p>
                  <div style="text-align: right; margin: 0">
                    <el-button size="mini" @click="switchVisible = false">{{ $t('cancel_btn') }}</el-button>
                    <el-button size="mini" type="primary" @click="handleConfirm">{{ $t('submit_btn') }}</el-button>
                  </div>
                  <el-switch
                    slot="reference"
                    :disabled="!$p('menu.payroll.management.edit')"
                    :value="switchValue"
                    @click.native.stop
                  ></el-switch>
                </el-popover>
              </div>
            </div>
            <div class="card-meta-desc">
              <p class="card-desc">{{ $t('payroll_management_6') }}</p>
            </div>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      currentData: {},
      switchVisible: false,
      switchValue: false
    }
  },
  created() {
    this.getCurrentData()
  },
  methods: {
    getCurrentData() {
      this.loading = true
      this.$http({
        url: '/web/payroll_setting/managelist',
        method: 'GET'
      })
        .then(res => {
          const item = res.data[0]
          this.currentData = item
          this.switchValue = item.status === '1'
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleConfirm() {
      this.switchVisible = false
      this.switchValue = !this.switchValue
      this.currentData.status = this.switchValue ? '1' : '0'
      this.$http({
        url: '/web/payroll_setting/updateSettingStatus',
        data: {
          setting_id: this.currentData.id,
          status: this.currentData.status
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.root .el-card {
  cursor: pointer;
}

.cards {
  display: flex;
  flex-wrap: wrap;
}

.cards .el-card {
  width: 320px;
  margin-right: 24px;
  margin-bottom: 16px;
}

.card-meta {
  display: flex;
}

.card-meta-icon {
  width: 24px;
  height: 24px;
}

.card-meta-icon .icon {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.card-meta-detail {
  flex: 1;
  margin-left: 8px;
}

.card-meta-title {
  display: flex;
  align-items: center;
}

.card-title {
  font-size: 16px;
  color: #262626;
  font-weight: 500;
  line-height: 24px;
}

.doubt {
  width: 16px;
  height: 16px;
  margin-left: 8px;
}

.switch {
  flex: 1;
  text-align: right;
}

.card-meta-desc {
  margin-top: 10px;
}

.card-desc {
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
}

.el-icon-warning {
  padding-bottom: 13px;
  word-break: break-word;
  &::before {
    color: #e6a23c;
    margin-right: 8px;
  }
}

.el-card:hover .card-title {
  color: #5D51DA;
  transition: color 0.3s ease;
}
</style>
